
/**
 * @param {?} event
 * @return {?}
 */
export function numericalInputOnly(event: KeyboardEvent): boolean {
  const /** @type {?} */ e = event.which || event.keyCode;
  const /** @type {?} */ isNumber = e < 58 && e > 47;

  if (isNumber) {
    return true;
  }

  return false;
}
